import React from 'react';
import { Check } from 'lucide-react';
import { Link } from 'react-router-dom';
const programs = [{
  name: 'Little Tigers',
  age: 'Ages 3-5',
  description: 'The perfect start for your little one. We focus on motor skills, listening, and fun in a safe environment.',
  features: ['Improve Coordination', 'Learn Respect', 'Burn Energy', 'Safety Awareness'],
  image: 'https://images.squarespace-cdn.com/content/v1/6782c238cf9313348308674a/e4359582-bcdb-4e7b-99f5-bd88fb19dd38/519631343_1291297066330671_8117759166597726015_n.jpg?format=500w',
  highlight: false,
  link: '/classes/taekwondo'
}, {
  name: 'Kids & Teens',
  age: 'Ages 6-17',
  description: 'Building strong character through martial arts. Confidence, discipline, and fitness for growing bodies and minds.',
  features: ['Better Focus', 'Anti-Bullying', 'Build Confidence', 'Character Development'],
  image: 'https://cdn.magicpatterns.com/uploads/5p1UpoVGYryaaKN4hFjNDT/emmalynn2BKICKBOXING2BCHILD2BCHAMPION.webp',
  highlight: true,
  link: '/classes/taekwondo'
}, {
  name: 'Family',
  age: 'All Ages',
  description: 'Train together, grow together. Our family classes create lasting bonds while everyone learns martial arts side by side.',
  features: ['Strengthen Family Bonds', 'Shared Goals', 'Quality Time Together', 'Family Discounts'],
  image: 'https://cdn.magicpatterns.com/uploads/qABRmAgUX6EG9Eygc3ZTW7/525151207_1299484922178552_984015317165030757_n.jpg',
  highlight: false,
  link: '/classes/taekwondo'
}, {
  name: 'Adults',
  age: 'Ages 18+',
  description: "It's never too late to start. Get in the best shape of your life while learning practical self-defense skills.",
  features: ['Stress Relief', 'Functional Fitness', 'Self-Defense', 'Community'],
  image: 'https://cdn.magicpatterns.com/uploads/3qnRFVQtwvWf6wzs5RVcEs/520100279_1289065393220505_343635053402736819_n.jpg',
  highlight: false,
  link: '/classes/taekwondo'
}, {
  name: 'Homeschool',
  age: 'Ages 6 & Up',
  description: 'Stay active, build confidence, and learn real self-defense in a positive, structured environment designed for homeschool families.',
  features: ['Small Group Instruction', 'Confidence & Community', 'Tues & Thurs 11:00-11:55 AM', 'Connection & Growth'],
  image: 'https://cdn.magicpatterns.com/uploads/k4uUtQqJeKnMSjqNUumRTE/homeschool.png',
  highlight: false,
  link: '/classes/homeschool',
  imagePosition: 'bottom'
}, {
  name: 'Private Lessons',
  age: 'All Ages',
  description: 'One-on-one instruction tailored to your specific goals. Flexible scheduling and personalized attention.',
  features: ['Personalized Training', 'Flexible Schedule', 'Accelerated Learning', 'Individual Focus'],
  image: 'https://cdn.magicpatterns.com/uploads/hz6wX1bJeUfa2vrVH8AW6q/PrivateLessons1_exif_stripped.jpg',
  highlight: false,
  link: '/classes/private-classes',
  imagePosition: 'center'
}, {
  name: 'Self Defense Seminars',
  age: 'Individual, Group & Corporate',
  description: 'Specialized self-defense training for individuals, groups, and corporate teams. Learn practical skills in a focused environment.',
  features: ['Individual Sessions', 'Group Workshops', 'Corporate Training', 'Practical Skills'],
  image: 'https://cdn.magicpatterns.com/uploads/parEZFrKpJJiTUFk8rBbbo/Seminars.png',
  highlight: false,
  link: '/classes/self-defense-seminars'
}];
export function ProgramsGrid() {
  return <section id="programs" className="py-24 bg-[#1a1a1a] text-white" data-id="element-1653">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1654">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-6" data-id="element-1655">
          <div className="max-w-2xl" data-id="element-1656">
            <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-1657">
              Programs For Every Age
            </h2>
            <div className="w-20 h-1 bg-[#00D4FF] mb-6" data-id="element-1658" />
            <p className="text-gray-400 text-lg" data-id="element-1659">
              Whether you're looking to build confidence in your child or get
              fit yourself, we have a program designed for your specific goals.
            </p>
          </div>
          <a href="/schedule" className="text-[#00D4FF] font-bold uppercase tracking-wider hover:text-white transition-colors flex items-center gap-2" data-id="element-1660">
            View Full Schedule <span aria-hidden="true" data-id="element-1661">&rarr;</span>
          </a>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 mb-8" data-id="element-1662">
          {programs.slice(0, 4).map((program, index) => <div key={program.name} className={`animate-scroll-fade-up relative rounded-2xl overflow-hidden group ${program.highlight ? 'ring-2 ring-[#00D4FF] shadow-[0_0_30px_rgba(0,212,255,0.15)]' : 'border border-gray-800'}`} style={{
          animationDelay: `${index * 0.1}s`
        }} data-id="element-1663">
              <Link to={program.link} className="block" data-id="element-1664">
                <div className="h-48 overflow-hidden relative" data-id="element-1665">
                  <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-colors z-10" data-id="element-1666" />
                  <img src={program.image} alt={program.name} className={`w-full h-full object-cover ${program.imagePosition === 'center' ? 'object-center' : program.imagePosition === 'bottom' ? 'object-bottom' : 'object-top'} group-hover:scale-110 transition-transform duration-700`} data-id="element-1667" />
                  <div className="absolute bottom-4 left-4 z-20" data-id="element-1668">
                    <span className="inline-block px-3 py-1 bg-[#00D4FF] text-black text-xs font-bold uppercase tracking-wider rounded-full mb-2" data-id="element-1669">
                      {program.age}
                    </span>
                    <h3 className="text-2xl font-bold text-white" data-id="element-1670">
                      {program.name}
                    </h3>
                  </div>
                </div>
              </Link>
              <div className="p-6 bg-[#222]" data-id="element-1671">
                <p className="text-gray-400 mb-6 min-h-[80px]" data-id="element-1672">
                  {program.description}
                </p>
                <ul className="space-y-3 mb-8" data-id="element-1673">
                  {program.features.map(feature => <li key={feature} className="flex items-start gap-3 text-sm text-gray-300" data-id="element-1674">
                      <Check className="w-5 h-5 text-[#00D4FF] shrink-0" data-id="element-1675" />
                      {feature}
                    </li>)}
                </ul>
                <a href={program.name === 'Private Lessons' || program.name === 'Self Defense Seminars' ? '/contact' : '/free-trial'} className="w-full py-3 rounded border border-gray-600 text-white font-bold uppercase tracking-wider hover:bg-white hover:text-black transition-colors block text-center" data-id="element-1676">
                  {program.name === 'Private Lessons' || program.name === 'Self Defense Seminars' ? 'Contact Us for Details' : 'Schedule Free Trial'}
                </a>
              </div>
            </div>)}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-1677">
          {programs.slice(4).map((program, index) => <div key={program.name} className="animate-scroll-fade-up relative rounded-2xl overflow-hidden group border border-gray-800" style={{
          animationDelay: `${index * 0.1}s`
        }} data-id="element-1678">
              <Link to={program.link} className="block" data-id="element-1679">
                <div className="h-48 overflow-hidden relative" data-id="element-1680">
                  <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-colors z-10" data-id="element-1681" />
                  <img src={program.image} alt={program.name} className={`w-full h-full object-cover ${program.imagePosition === 'center' ? 'object-center' : program.imagePosition === 'bottom' ? 'object-bottom' : 'object-top'} group-hover:scale-110 transition-transform duration-700`} data-id="element-1682" />
                  <div className="absolute bottom-4 left-4 z-20" data-id="element-1683">
                    <span className="inline-block px-3 py-1 bg-[#00D4FF] text-black text-xs font-bold uppercase tracking-wider rounded-full mb-2" data-id="element-1684">
                      {program.age}
                    </span>
                    <h3 className="text-2xl font-bold text-white" data-id="element-1685">
                      {program.name}
                    </h3>
                  </div>
                </div>
              </Link>
              <div className="p-6 bg-[#222]" data-id="element-1686">
                <p className="text-gray-400 mb-6 min-h-[80px]" data-id="element-1687">
                  {program.description}
                </p>
                <ul className="space-y-3 mb-8" data-id="element-1688">
                  {program.features.map(feature => <li key={feature} className="flex items-start gap-3 text-sm text-gray-300" data-id="element-1689">
                      <Check className="w-5 h-5 text-[#00D4FF] shrink-0" data-id="element-1690" />
                      {feature}
                    </li>)}
                </ul>
                <a href={program.name === 'Private Lessons' || program.name === 'Self Defense Seminars' ? '/contact' : '/free-trial'} className="w-full py-3 rounded border border-gray-600 text-white font-bold uppercase tracking-wider hover:bg-white hover:text-black transition-colors block text-center" data-id="element-1691">
                  {program.name === 'Private Lessons' || program.name === 'Self Defense Seminars' ? 'Contact Us for Details' : 'Schedule Free Trial'}
                </a>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}